import styled, { css } from 'styled-components';

export const Place = styled.div`
  position: absolute;
  top: ${(props) => props.$topPos ?? '45px'};
  z-index: 10;
  box-shadow: 0px 1px 15px rgba(0, 0, 0, 0.32);
  background: #5f6872;
  color: #fff;
  padding: 15px;
  max-width: 100%;
  min-width: ${(props) => props.$minWidth ?? '280px'};
  border-radius: 4px;
  &:before {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #5f6872;
    top: -9px;
    left: ${(props) => props.$arrowPos ?? '50px'};
  }
  ${(props) =>
    props.$above &&
    css`
      bottom: 45px;
      top: auto;
      &:before {
        top: auto;
        bottom: -9px;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #444;
        border-bottom: 0;
      }
    `}
`;

export const Content = styled.div``;

export const SimpleModalButtons = styled.div`
  background-color: #444;
  margin: 15px -15px -15px;
  display: flex;
  justify-content: space-between;
  padding: 15px;
  button {
    min-width: 60px;
  }
`;

export const SimpleModalTitle = styled.div`
  font-size: 18px;
  line-height: normal;
  margin: 0 0 15px;
  text-align: center;
`;
